import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        guid: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'user.Preview Materials' | translate }}</h2>
        </div>
        <div style="min-height:100vh; height:100%;">
        <iframe
            allowfullscreen
            frameborder="0"
            height="100%"
            width="100%"
            src="{{ vm.url }}"
        >
        </iframe>
        </div>

        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button
                        class="btn main"
                        type="button"
                        ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Ok' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($window, $translate, $sce, ModalService, $state) {
        this.$translate = $translate;
        this.$sce = $sce;
        this.ModalService = ModalService;
        this.$state = $state;
        this.height = $window.innerHeight * 90 / 100;
        this.width = $window.innerHeight * 90 / 100;
        this.url = this.getIframeUrl();
    }

    getIframeUrl () {
        const params = {
            guid: this.guid
        };
        return this.$state.href('material.do', params);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/version/training/materialPreview/iframe/index.js